import React from 'react';
import InvitePendingIcon from 'Dashboard/components/InvitePendingIcon/InvitePendingIcon';
import { WpIcon } from 'Wpds/components/icon';

const isNotInvitedAvatar = avatarUrl => ({
  color: '#FFAA7A',
  initials: '!',
  outerWrapperColor: '#e17333',
  profilePictureUrl: avatarUrl,
});
const isInvitePendingAvatar = avatarUrl => ({
  color: '#C4C4C4',
  initials: avatarUrl ? '' : <InvitePendingIcon />,
  profilePictureUrl: avatarUrl,
});
const nudgeBotAvatar = {
  color: '#D8EFF0',
  initials: (
    <span style={{ color: '#347D82', fontSize: '17px' }}>
      <WpIcon name="robot" />
    </span>
  ),
  profilePictureUrl: null,
};

export const fakeNudgebotData = {
  id: 'nudgebot',
  displayName: 'Sales Assistant',
  displayAvatar: nudgeBotAvatar,
  isNotInvited: false,
  isInvitePending: false,
  path: '/recommendations',
};

export const getTeammateItemAvatar = ({ user, avatarUrl }) => {
  if (!user) return isNotInvitedAvatar(avatarUrl);
  if (!user.confirmedAt && user.confirmationSentAt) return isInvitePendingAvatar(avatarUrl);
  return user.avatar;
};
